/**
 * @fileoverview gRPC-Web generated client stub for accountpb
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var proto_utilspb_pagination_pb = require('../../proto/utilspb/pagination_pb.js')
const proto = {};
proto.accountpb = require('./customertype_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.accountpb.CustomerTypeServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.accountpb.CustomerTypeServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.ListCustomerTypeRequest,
 *   !proto.accountpb.ListCustomerTypeResponse>}
 */
const methodDescriptor_CustomerTypeService_ListCustomerType = new grpc.web.MethodDescriptor(
  '/accountpb.CustomerTypeService/ListCustomerType',
  grpc.web.MethodType.UNARY,
  proto.accountpb.ListCustomerTypeRequest,
  proto.accountpb.ListCustomerTypeResponse,
  /**
   * @param {!proto.accountpb.ListCustomerTypeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.ListCustomerTypeResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.accountpb.ListCustomerTypeRequest,
 *   !proto.accountpb.ListCustomerTypeResponse>}
 */
const methodInfo_CustomerTypeService_ListCustomerType = new grpc.web.AbstractClientBase.MethodInfo(
  proto.accountpb.ListCustomerTypeResponse,
  /**
   * @param {!proto.accountpb.ListCustomerTypeRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.ListCustomerTypeResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.ListCustomerTypeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.accountpb.ListCustomerTypeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.ListCustomerTypeResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.CustomerTypeServiceClient.prototype.listCustomerType =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.CustomerTypeService/ListCustomerType',
      request,
      metadata || {},
      methodDescriptor_CustomerTypeService_ListCustomerType,
      callback);
};


/**
 * @param {!proto.accountpb.ListCustomerTypeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.ListCustomerTypeResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.CustomerTypeServicePromiseClient.prototype.listCustomerType =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.CustomerTypeService/ListCustomerType',
      request,
      metadata || {},
      methodDescriptor_CustomerTypeService_ListCustomerType);
};


module.exports = proto.accountpb;

